import styled from "styled-components";
import * as assests from "../../../_assests";

export const Empty = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #aaa;
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -20px;

  @media (min-width: 900px) {
    justify-content: flex-start;
  }
`;

export const ContractZoom = styled.div`
  display: none;
  position: absolute;
  right: 22px;
  width: 30px;
  height: 30px;
  z-index: 1;
  cursor: pointer;

  > svg {
    fill: ${(props) => props.theme.orange};
  }
`;

export const AppealData = styled.div`
  display: flex;
  max-width: 100%;
  padding: 22px;
  cursor: pointer;

  @media (min-width: 880px) {
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    width: 290px;
  }
`;

export const AppealParam = styled.div<{ cols?: boolean }>`
  display: ${(props) => (props.cols ? "flex" : "block")};
  justify-content: space-between;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.black};
  margin-bottom: 22px;
  margin-right: 22px;

  @media (min-width: 880px) {
    margin-right: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  span {
    width: 48%;
  }

  b {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
  }

  u {
    display: block;
    text-decoration: none;
    margin-bottom: 5px;
    font-size: 12px;
    line-height: 14px;
    color: #a3a3a5;
  }

  strong {
    font-size: 11px;
    font-weight: bold;
    color: ${(props) => props.theme.orange};
  }
`;

export const AppealContent = styled.div`
  flex: 1;
  background-color: #f3f3f3;
  padding: 25px 25px 0 25px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .ant-steps {
    width: 90%;
    margin-bottom: 10px;
  }

  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    height: 1.5px;
    background-color: #ccc;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    height: 1.5px;
    background: #ccc;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
    color: #2b314f;
  }

  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.45);
  }

  .ant-steps-item-title {
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
  }

  @media (max-width: 576px) {
    .ant-steps {
      width: 90%;
      margin: 0;
    }
  }
`;

export const AppealZoom = styled(assests.ZoomOutIcon)`
  display: none;
  position: absolute;
  right: 22px;
  bottom: 22px;
  width: 30px;
  height: 30px;
  z-index: 2;
  cursor: pointer;
`;

export const Appeal = styled.div<{ maximized?: boolean; featured?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: ${(props) => (props.maximized ? "1 1 100%" : "none")};
  overflow: hidden;
  max-width: ${(props) => (props.maximized ? "100%" : "300px")};
  min-height: 250px;
  margin: 20px 20px;
  border-radius: 20px;
  border: 1px solid #ffb614;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  background: ${(props) =>
    props.maximized || props.featured
      ? "linear-gradient(180deg, #76CFF0 0%, #FFFFFF 30.73%)"
      : "#fff"};

  @media (min-width: 880px) {
    flex-direction: row;
    min-width: 300px;
    order: ${(props) => (props.maximized ? -1 : "auto")};
  }

  &:hover {
    border: none;
    background: linear-gradient(180deg, #76cff0 0%, #ffffff 30.73%);
  }

  ${AppealParam}:last-child {
    margin-top: ${(props) => (props.maximized ? "0" : "auto")};
  }

  ${AppealZoom} {
    display: ${(props) => (props.maximized ? "block" : "none")};
  }

  ${AppealData} {
    @media (max-width: 880px) {
      justify-content: ${(props) =>
        props.maximized ? "space-between" : "flex-start"};
      flex-wrap: ${(props) => (props.maximized ? "wrap" : "nowrap")};
      flex-direction: ${(props) => (props.maximized ? "row" : "column")};
    }
  }
`;

export const Messages = styled.div`
  width: 70%;
  margin-bottom: 40px;
`;

export const MessageHead = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const MessageDate = styled.div`
  font-size: 11px;
  line-height: 14px;
  color: #8f9091;
`;

export const MessageText = styled.div`
  margin-top: 11px;
  padding: 7px 13px;
  background: #ffffff;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 15px;
  line-height: 20px;
`;

export const MessageFiles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 10px;
  padding: 0 3px;
  color: #555;
  font-size: 12px;
  line-height: 14px;

  button {
    margin-bottom: 4px;
    padding: 0;
    background-color: transparent;

    &:focus {
      color: inherit;
    }

    > svg {
      display: inline-block;
      height: 15px;
      width: 15px;
      margin-right: 7px;
      margin-bottom: 1px;
      vertical-align: sub;
    }
  }
  .ant-btn > span {
    font-size: 10px;
  }
`;

export const TitleStep = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Message = styled.div<{ answer?: boolean }>`
  margin-bottom: 25px;

  ${MessageHead} {
    justify-content: ${(props) => (props.answer ? "flex-end" : "flex-start")};
  }
`;

export const StepBlockDis = styled.div`
  stop {
    stop-color: #8f9090;
  }
`;

export const StepBlockDone = styled.div`
  stop {
    stop-color: #00aae0;
  }
  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.45);
  }
`;
